module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"imprint":"Impressum","noLegalInfo":"Keine rechtlichen Informationen bisher vorhanden"},"en":{"imprint":"Imprint","noLegalInfo":"No legal information yet"}}')
  delete Component.options._Ctor
}
